
import React, { useState,useEffect } from "react";
import "../Styles/WristbandProduct.css";
import { useNavigate } from "react-router-dom";
import logo from "../Assest/newcluster.png";
import wristbandImage1 from "../Assest/D55ABC31-9662-41A5-A0CB-672C1E80B962-removebg-preview.png";
import wristbandImage2 from "../Assest/IMG_8805-removebg-preview.png";
import { motion, AnimatePresence } from "framer-motion";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";

import Footer from "./Footer";
import axios from "axios";
import WhatsAppButton from "./WhatsAppButton";
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const viewportSettings = {
  once: true,
  amount: 0.2,
};

const fadeIn = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.8,
    },
  },
};

const scaleIn = {
  hidden: {
    opacity: 0,
    scale: 0.94,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const buttonHover = {
  y: -3,
  scale: 1.02,
};

const buttonTap = {
  scale: 0.97,
};

  const api = process.env.REACT_APP_API_URL;
const reviews = [
  {
    name: "Daniel M.",
    role: "Barber",
    text: "This is honestly one of the coolest business tools I've bought. Customers just tap my wrist and get everything.",
  },
  {
    name: "Marcus T.",
    role: "DJ",
    text: "I don't even have to explain it anymore. People see the band, tap it and my socials open instantly.",
  },
  {
    name: "Sarah K.",
    role: "Creator",
    text: "Way better than handing someone a business card. It feels premium and actually gets people interacting with my profile.",
  },
  {
    name: "James R.",
    role: "Personal Trainer",
    text: "I meet new people all the time, so having everything on my wrist makes sharing my business much easier.",
  },
  {
    name: "Amara B.",
    role: "Hair Stylist",
    text: "I love how simple it is. One tap and clients can see my work, socials and booking details.",
  },
  {
    name: "Michael O.",
    role: "Photographer",
    text: "It looks professional and saves me from having to search for my social profiles whenever someone asks for them.",
  },
  {
    name: "Chris A.",
    role: "Entrepreneur",
    text: "The idea is so simple but really useful. Everything I want people to see is connected to one tap.",
  },
  {
    name: "Tasha L.",
    role: "Content Creator",
    text: "I was looking for something different from a normal business card and this does exactly that.",
  },
  {
    name: "David K.",
    role: "Musician",
    text: "It's become an easy conversation starter. People notice the wristband and immediately want to know how it works.",
  },
  {
    name: "Jessica P.",
    role: "Beauty Professional",
    text: "Being able to share my booking page and socials without handing out cards is really convenient.",
  },
];


const productImages = [
  {
    id: "front",
    src: wristbandImage1,
    alt: "ClusterClear NFC wristband front view",
  },
  {
    id: "side",
    src: wristbandImage2,
    alt: "ClusterClear NFC wristband side view",
  },
  
];

export default function WristbandProduct() {
 
const getSource = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("utm_source") || "direct";
};
const [selectedImage, setSelectedImage] = useState(0);
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [email, setEmail] = useState("");
  const [referralCode, setReferralCode] = useState("");
const [searchParams] = useSearchParams();

const [couponCode, setCouponCode] = useState(
  searchParams.get("promo") || ""
);

  const price = 29.99;
const navigate = useNavigate();








const handleBuy = () => {
  setShowCheckoutModal(true);
};




const handleCheckout = async () => {
  if (!email.trim()) {
    toast.error("Please enter your email address.");
    return;
  }

  try {
    const { data } = await axios.post(
      `${api}/create-checkout-session`,
      {
        email: email.trim(),
        referralCode: referralCode.trim(),
        couponCode: couponCode.trim(),
      }
    );

    console.log("Checkout session data:", data);

    if (data.url) {
      window.location.href = data.url;
    } else {
      toast.error("Unable to start checkout. Please try again.");
    }

  } catch (error) {
    console.error("Checkout error:", error);

    toast.error(
      error.response?.data?.message ||
      "Unable to start checkout. Please try again."
    );
  }
};


useEffect(() => {
  const trackProductVisit = async () => {
    try {
      const source = getSource();

      await fetch(`${api}/track-visit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          source,
          page: "/product",
        }),
      });
    } catch (error) {
      console.error("Product visit tracking error:", error);
    }
  };

  trackProductVisit();
}, []);

  return (
    <>
  <WhatsAppButton/>
    <div className="cc-store">

      {/* Announcement */}
     <motion.div
  className="announcement"
  initial={{ opacity: 0, y: -15 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
>
        <span>FREE UK DELIVERY</span>
        <span className="announcement-dot">•</span>
        <span>NO CHARGING REQUIRED</span>
                <span className="announcement-dot">•</span>
          <span> WATER PROOF</span>
      </motion.div>

     {/* Navigation */}
<motion.nav
  className="cc-nav"
  initial={{ opacity: 0, y: -20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{
    duration: 0.7,
    delay: 0.15,
    ease: [0.22, 1, 0.36, 1],
  }}
>

  <a href="/" className="cc-logo">
    <img src={logo} alt="ClusterClear" />
  </a>

  <div className="nav-links">
    <a href="#how-it-works">How it works</a>
    <a href="#reviews">Reviews</a>
    <a href="#faq">FAQ</a>
  </div>

  <div className="nav-actions">
<motion.button
  className="nav-login"
  onClick={() => navigate("/login")}
  whileHover={buttonHover}
  whileTap={buttonTap}
>
  My Wristband
</motion.button>

    <motion.button
  className="nav-buy"
  onClick={handleBuy}
  whileHover={buttonHover}
  whileTap={buttonTap}
>
  Buy now
</motion.button>
  </div>

</motion.nav>
      <main>

        {/* HERO */}
       {/* HERO */}
<section className="product-section">

  <motion.div
    className="product-visual"
    variants={fadeIn}
    initial="hidden"
    animate="visible"
    transition={{ duration: 0.9, delay: 0.25 }}
  >

    <motion.div
      className="image-card"
      initial={{ opacity: 0, scale: 0.94, y: 25 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{
        duration: 0.9,
        delay: 0.3,
        ease: [0.22, 1, 0.36, 1],
      }}
    >

      <motion.div
        className="image-glow"
        animate={{
          scale: [1, 1.04, 1],
          opacity: [0.7, 0.9, 0.7],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <AnimatePresence mode="wait">

        <motion.img
          key={productImages[selectedImage].id}
          src={productImages[selectedImage].src}
          alt={productImages[selectedImage].alt}
          className="wristband-product-image"
          initial={{
            opacity: 0,
            scale: 0.96,
          }}
          animate={{
            opacity: 1,
            scale: 1,
          }}
          exit={{
            opacity: 0,
            scale: 1.02,
          }}
          transition={{
            duration: 0.45,
            ease: [0.22, 1, 0.36, 1],
          }}
        />

      </AnimatePresence>


      {/* FLOATING BADGES */}

      <AnimatePresence>

        {selectedImage === 0 && (
          <motion.div
            className="floating-badge badge-one"
            initial={{
              opacity: 0,
              y: 15,
              scale: 0.9,
            }}
            animate={{
              opacity: 1,
              y: [0, -5, 0],
              scale: 1,
            }}
            exit={{
              opacity: 0,
              y: -10,
              scale: 0.9,
            }}
            transition={{
              opacity: {
                duration: 0.35,
              },
              scale: {
                duration: 0.35,
              },
              y: {
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              },
            }}
          >
            <span className="live-dot" />
            Tap to share
          </motion.div>
        )}

      </AnimatePresence>


      <AnimatePresence>

        {selectedImage === 0 && (
          <motion.div
            className="floating-badge badge-two"
            initial={{
              opacity: 0,
              y: 15,
              scale: 0.9,
            }}
            animate={{
              opacity: 1,
              y: [0, 5, 0],
              scale: 1,
            }}
            exit={{
              opacity: 0,
              y: 10,
              scale: 0.9,
            }}
            transition={{
              opacity: {
                duration: 0.35,
                delay: 0.1,
              },
              scale: {
                duration: 0.35,
                delay: 0.1,
              },
              y: {
                duration: 3.5,
                repeat: Infinity,
                ease: "easeInOut",
              },
            }}
          >
            NFC enabled
          </motion.div>
        )}

      </AnimatePresence>

    </motion.div>


    {/* THUMBNAILS */}

    <motion.div
      className="thumbnail-row"
      variants={staggerContainer}
      initial="hidden"
      animate="visible"
      transition={{ delayChildren: 0.7 }}
    >

      {productImages.map((image, index) => (

        <motion.button
          key={image.id}
          type="button"
          className={`thumbnail ${
            selectedImage === index ? "active" : ""
          }`}
          onClick={() => setSelectedImage(index)}
          aria-label={`View ${image.alt}`}
          variants={scaleIn}
          whileHover={buttonHover}
          whileTap={buttonTap}
        >

          <img
            src={image.src}
            alt={image.alt}
          />

        </motion.button>

      ))}

    </motion.div>

  </motion.div>


  {/* PRODUCT INFO */}

  <motion.div
    className="product-info"
    variants={staggerContainer}
    initial="hidden"
    animate="visible"
    transition={{
      delayChildren: 0.45,
      staggerChildren: 0.12,
    }}
  >

    <motion.div
      className="rating"
      variants={fadeUp}
    >
      <span className="stars">★★★★★</span>
      <span>4.9</span>
      <a href="#reviews">
        [{reviews.length}] reviews
      </a>
    </motion.div>


    <motion.p
      className="eyebrow"
      variants={fadeUp}
    >
      SMART NFC WRISTBAND
    </motion.p>


    <motion.h1
      variants={fadeUp}
    >
      Your business.
      <br />
      <span>Always with you.</span>
    </motion.h1>


    <motion.p
      className="product-description"
      variants={fadeUp}
    >
      One tap gives people instant access to your social media,
      website, WhatsApp, booking page and everything else you
      want them to see.
    </motion.p>


    <motion.div
      className="price-row"
      variants={fadeUp}
    >
      <strong>£{price.toFixed(2)}</strong>

      <span className="price-note">
        One-time purchase
      </span>
    </motion.div>


    <motion.div
      className="benefits"
      variants={staggerContainer}
    >

      {[
        "No charging required",
        "iPhone & Android",
        "Water resistant",
        "Update links anytime",
      ].map((benefit) => (

        <motion.div
          key={benefit}
          variants={fadeUp}
        >
          <span className="check">✓</span>
          {benefit}
        </motion.div>

      ))}

    </motion.div>


    <motion.button
      className="primary-buy"
      onClick={handleBuy}
      variants={fadeUp}
      whileHover={buttonHover}
      whileTap={buttonTap}
    >
      <span>Get your ClusterClear</span>

      <span>
        £{price.toFixed(2)} →
      </span>
    </motion.button>


    <motion.div
      className="secure-checkout"
      variants={fadeUp}
    >
      <span>🔒</span>
      Secure checkout powered by Stripe
    </motion.div>


    <motion.div
      className="delivery"
      variants={fadeUp}
    >

      <motion.div
        className="delivery-icon"
        animate={{
          y: [0, -3, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        ↗
      </motion.div>

      <div>
        <strong>Free UK delivery</strong>

        <span>
          Dispatched within 1–2 working days
        </span>
      </div>

    </motion.div>

  </motion.div>

</section>

        {/* TRUST STRIP */}
      {/* TRUST STRIP */}

<motion.section
  className="trust-strip"
  variants={staggerContainer}
  initial="hidden"
  whileInView="visible"
  viewport={viewportSettings}
>

  <motion.div variants={fadeUp}>
    <strong>01</strong>
    <span>Tap your wrist</span>
  </motion.div>

  <motion.div variants={fadeUp}>
    <strong>02</strong>
    <span>They get your links</span>
  </motion.div>

  <motion.div variants={fadeUp}>
    <strong>03</strong>
    <span>You make the connection</span>
  </motion.div>

</motion.section>

        {/* FEATURES */}
  

<motion.section
  className="feature-section"
  initial="hidden"
  whileInView="visible"
  viewport={viewportSettings}
>

  <motion.div
    className="section-heading"
    variants={fadeUp}
  >

    <p className="eyebrow">
      MORE THAN A WRISTBAND
    </p>

    <h2>
      Stop giving people
      <br />
      <span>something they lose.</span>
    </h2>

    <p>
      Your business card gets forgotten.
      Your ClusterClear stays on your wrist.
    </p>

  </motion.div>


  <motion.div
    className="feature-grid"
    variants={staggerContainer}
  >

    <motion.div variants={fadeUp}>
      <Feature
        number="01"
        title="One tap."
        text="People simply tap your wristband with their phone. Your digital profile opens instantly."
      />
    </motion.div>

    <motion.div variants={fadeUp}>
      <Feature
        number="02"
        title="Everything in one place."
        text="Instagram, TikTok, WhatsApp, website, booking links and more — all behind one tap."
      />
    </motion.div>

    <motion.div variants={fadeUp}>
      <Feature
        number="03"
        title="Always up to date."
        text="Change your links from your ClusterClear account without replacing the wristband."
      />
    </motion.div>

  </motion.div>

</motion.section>

      {/* HOW IT WORKS */}

<motion.section
  className="how-section"
  id="how-it-works"
  initial="hidden"
  whileInView="visible"
  viewport={{
    once: true,
    amount: 0.25,
  }}
>

  <motion.div
    className="how-copy"
    variants={fadeUp}
  >

    <p className="eyebrow">
      HOW IT WORKS
    </p>

    <h2>
      It takes
      <br />
      <span>one tap.</span>
    </h2>

    <p>
      No app. No battery. No complicated setup.
      Just tap and connect.
    </p>


    <motion.div
      className="how-points"
      variants={staggerContainer}
    >

      <motion.div variants={fadeUp}>
        <span>01</span>
        <p>
          Wear your ClusterClear wristband.
        </p>
      </motion.div>

      <motion.div variants={fadeUp}>
        <span>02</span>
        <p>
          Someone taps their NFC-enabled phone.
        </p>
      </motion.div>

      <motion.div variants={fadeUp}>
        <span>03</span>
        <p>
          Your digital profile appears instantly.
        </p>
      </motion.div>

       <motion.div variants={fadeUp}>
        <span>04</span>
       
       <a style={{ textDecoration: 'none' }} href="https://www.instagram.com/reel/DcL5zi4sjLx/?stkn=MTdraGludXA5dWl1dQ==" target="_blank" rel="noopener noreferrer">
         <p>
           See demo 
         </p>
       </a>
      </motion.div>

    </motion.div>

  </motion.div>


  <motion.div
    className="phone-demo"
    variants={scaleIn}
  >

    <motion.div
      className="phone"
      animate={{
        y: [0, -8, 0],
      }}
      transition={{
        duration: 4,
        repeat: Infinity,
        ease: "easeInOut",
      }}
    >

      <div className="phone-camera" />

      <div className="phone-content">

        <motion.div
          className="profile-circle"
          initial={{ scale: 0 }}
          whileInView={{ scale: 1 }}
          viewport={{ once: true }}
          transition={{
            duration: 0.6,
            delay: 0.3,
            type: "spring",
            stiffness: 180,
          }}
        >
          CC
        </motion.div>

        <h3>
          ClusterClear
        </h3>

        <p>
          Connect with me
        </p>

        <motion.div
          className="fake-link"
          whileHover={{ scale: 1.03, x: 4 }}
        >
          Instagram
        </motion.div>

        <motion.div
          className="fake-link"
          whileHover={{ scale: 1.03, x: 4 }}
        >
          WhatsApp
        </motion.div>

        <motion.div
          className="fake-link"
          whileHover={{ scale: 1.03, x: 4 }}
        >
          My Website
        </motion.div>

      </div>

    </motion.div>

  </motion.div>

</motion.section>

        {/* REVIEWS */}
{/* REVIEWS */}

<motion.section
  className="product-reviews-section"
  id="product-reviews"
  initial="hidden"
  whileInView="visible"
  viewport={viewportSettings}
>

  <motion.div
    className="product-reviews-header"
    variants={fadeUp}
  >

    <div>

      <p className="product-reviews-eyebrow">
        CUSTOMER REVIEWS
      </p>

      <h2>
        Loved by people
        <br />
        <span>who build.</span>
      </h2>

    </div>


    <motion.div
      className="product-overall-rating"
      variants={scaleIn}
    >

      <strong>4.9</strong>

      <div className="product-review-stars">
        ★★★★★
      </div>

      <span>
        {reviews.length} verified reviews
      </span>

    </motion.div>

  </motion.div>


  <motion.div
    className="product-reviews-grid"
    variants={staggerContainer}
  >

    {reviews.map((review) => (

      <motion.article
        className="product-review-card"
        key={review.name}
        variants={fadeUp}
        whileHover={{
          y: -6,
        }}
        transition={{
          duration: 0.25,
        }}
      >

        <div className="product-review-stars">
          ★★★★★
        </div>

        <p>
          "{review.text}"
        </p>

        <div className="product-review-author">

          <motion.div
            className="product-review-avatar"
            whileHover={{
              scale: 1.08,
            }}
          >
            {review.name.charAt(0)}
          </motion.div>

          <div>
            <strong>
              {review.name}
            </strong>

            <span>
              {review.role}
            </span>
          </div>

          <span className="product-review-verified">
            ✓ Verified
          </span>

        </div>

      </motion.article>

    ))}

  </motion.div>

</motion.section>
     {/* FINAL CTA */}

<motion.section
  className="final-cta"
  initial="hidden"
  whileInView="visible"
  viewport={{
    once: true,
    amount: 0.3,
  }}
>

  <motion.p
    className="eyebrow"
    variants={fadeUp}
  >
    CARRY YOUR BUSINESS
  </motion.p>

  <motion.h2
    variants={fadeUp}
  >
    Your next customer
    <br />
    <span>could be one tap away.</span>
  </motion.h2>

  <motion.button
    className="primary-buy"
    onClick={handleBuy}
    variants={scaleIn}
    whileHover={{
      y: -4,
      scale: 1.03,
    }}
    whileTap={{
      scale: 0.97,
    }}
  >

    <span>
      Get your ClusterClear
    </span>

    <span>
      £{price.toFixed(2)} →
    </span>

  </motion.button>

  <motion.p variants={fadeUp}>
    Free UK delivery · Secure checkout ·
    No subscription
  </motion.p>

</motion.section>

       {/* FAQ */}

<motion.section
  className="faq"
  id="faq"
  initial="hidden"
  whileInView="visible"
  viewport={viewportSettings}
>

  <motion.p
    className="eyebrow"
    variants={fadeUp}
  >
    FAQ
  </motion.p>

  <motion.h2
    variants={fadeUp}
  >
    Questions?
  </motion.h2>


  <motion.details variants={fadeUp}>
    <summary>
      Does it need charging?
    </summary>

    <p>
      No. ClusterClear uses NFC technology and
      does not contain a battery, so there is
      nothing to charge.
    </p>
  </motion.details>


  <motion.details variants={fadeUp}>
    <summary>
      Does it work with iPhone?
    </summary>

    <p>
      Yes. Compatible iPhones and Android phones
      can read the NFC wristband.
    </p>
  </motion.details>


  <motion.details variants={fadeUp}>
    <summary>
      Can I change my links?
    </summary>

    <p>
      Yes. Your ClusterClear profile can be
      updated whenever you want without replacing
      the wristband.
    </p>
  </motion.details>


  <motion.details variants={fadeUp}>
    <summary>
      Is there a monthly subscription?
    </summary>

    <p>
      The wristband is purchased upfront. Any
      optional premium analytics features can be
      added separately later.
    </p>
  </motion.details>

</motion.section>

      </main>

      {/* MOBILE BUY BAR */}
      <div className="mobile-buy">

        <div>
          <span>
            ClusterClear
          </span>

          <strong>
            £{price.toFixed(2)}
          </strong>
        </div>

        <button onClick={handleBuy}>
          Buy now →
        </button>

      </div>

      {/* CHECKOUT DETAILS MODAL */}
<AnimatePresence>
  {showCheckoutModal && (

    <motion.div
      className="checkout-modal-overlay"
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
      }}
      transition={{
        duration: 0.25,
      }}
      onClick={() => setShowCheckoutModal(false)}
    >

      <motion.div
        className="checkout-modal"
        initial={{
          opacity: 0,
          y: 30,
          scale: 0.96,
        }}
        animate={{
          opacity: 1,
          y: 0,
          scale: 1,
        }}
        exit={{
          opacity: 0,
          y: 20,
          scale: 0.97,
        }}
        transition={{
          duration: 0.4,
          ease: [0.22, 1, 0.36, 1],
        }}
        onClick={(e) => e.stopPropagation()}
      >

        <motion.button
          className="checkout-modal-close"
          onClick={() => setShowCheckoutModal(false)}
          aria-label="Close"
          whileHover={{
            rotate: 90,
            scale: 1.1,
          }}
          whileTap={{
            scale: 0.9,
          }}
        >
          ×
        </motion.button>


        <motion.div
          className="checkout-modal-content"
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
        >

          <motion.p
            className="eyebrow"
            variants={fadeUp}
          >
            ALMOST THERE
          </motion.p>


          <motion.h2
            variants={fadeUp}
          >
            Let's get your
            <br />
            <span>ClusterClear ready.</span>
          </motion.h2>


          <motion.p
            className="checkout-modal-description"
            variants={fadeUp}
          >
            Enter your email before continuing to secure
            checkout. We'll use it to set up your wristband
            after your purchase.
          </motion.p>


          <motion.div
            className="checkout-modal-field"
            variants={fadeUp}
          >

            <label>
              Email address
            </label>

            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />

          </motion.div>


          <motion.div
            className="checkout-modal-field"
            variants={fadeUp}
          >

            <label>
              Referral code
              <span>Optional</span>
            </label>

            <input
              type="text"
              placeholder="Enter referral code"
              value={referralCode}
              onChange={(e) =>
                setReferralCode(e.target.value)
              }
            />
<motion.div
  className="checkout-modal-field"
  variants={fadeUp}
>
  <label>
    Coupon code
    <span>Optional</span>
  </label>

  <input
    type="text"
    placeholder="Enter coupon code"
    value={couponCode}
    onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
  />
</motion.div>
          </motion.div>


          <motion.button
            className="checkout-modal-button"
            onClick={handleCheckout}
            variants={fadeUp}
            whileHover={{
              y: -2,
              scale: 1.01,
            }}
            whileTap={{
              scale: 0.98,
            }}
          >
            <span>
              Continue to checkout
            </span>

            <span>
              →
            </span>

          </motion.button>


          <motion.div
            className="checkout-modal-secure"
            variants={fadeUp}
          >
            <span>🔒</span>
            Secure checkout powered by Stripe
          </motion.div>

        </motion.div>

      </motion.div>

    </motion.div>

  )}
</AnimatePresence>


<Footer/>
    </div>
      </>
  );
}

function Feature({
  number,
  title,
  text,
}) {
  return (
    <div className="feature-card">

      <span>
        {number}
      </span>

      <h3>
        {title}
      </h3>

      <p>
        {text}
      </p>


    </div>
    
  );
    
}

